import { render } from "./top-search.vue?vue&type=template&id=1bf54621&scoped=true"
import script from "./top-search.vue?vue&type=script&lang=ts"
export * from "./top-search.vue?vue&type=script&lang=ts"

import "./top-search.vue?vue&type=style&index=0&id=1bf54621&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1bf54621"

export default script